import { render, staticRenderFns } from "./DashboardPlanDetail.vue?vue&type=template&id=045f57a1&scoped=true&"
import script from "./DashboardPlanDetail.vue?vue&type=script&lang=js&"
export * from "./DashboardPlanDetail.vue?vue&type=script&lang=js&"
import style0 from "./DashboardPlanDetail.vue?vue&type=style&index=0&id=045f57a1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045f57a1",
  null
  
)

export default component.exports